export default class TierPricing {
  priceCents: number
  guestCount: number
  achieved: boolean

  constructor(attrs: any) {
    this.priceCents = attrs.priceCents
    this.guestCount = attrs.guestCount
    this.achieved = attrs.achieved
  }
}
